import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMobile = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M4.5 4C4.5 2.90625 5.375 2 6.5 2L13.5 2C14.5938 2 15.5 2.90625 15.5 4L15.5 16C15.5 17.125 14.5938 18 13.5 18H6.5C5.375 18 4.5 17.125 4.5 16L4.5 4ZM8.5 16C8.5 16.2812 8.71875 16.5 9 16.5H11C11.25 16.5 11.5 16.2812 11.5 16C11.5 15.75 11.25 15.5 11 15.5H9C8.71875 15.5 8.5 15.75 8.5 16ZM13.5 4L6.5 4L6.5 14L13.5 14L13.5 4Z"
	})
});
const ForwardRef = forwardRef(SvgMobile);
export default ForwardRef;
